import React, { useRef } from "react";
import classNames from "classnames";
import {
  generateHeadingDesignStyles,
  IWebsiteBuilderHeading,
} from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderHeading";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { TUpdatedElementSettings } from "redux/actions/websiteBuilder/actions/element/updateElementSettings";
import { websiteBuilderUpdateElementSettings } from "redux/actions/websiteBuilder/websiteBuilder";
import { cloneDeep } from "lodash";
import { useElementViewTextEditor } from "../../../hooks/element/useElementViewTextEditor/useElementViewTextEditor";

interface IWebsiteBuilderHeadingViewProps {
  node: IWebsiteBuilderHeading;
  editingText: boolean;
}

export function WebsiteBuilderHeadingView(props: IWebsiteBuilderHeadingViewProps) {
  const { node, editingText } = props;

  const dispatch = useAppDispatch();

  const selectedNodeId = useAppSelector(store => store.websiteBuilderStore.selectedNode?.id);
  const headingSelected = selectedNodeId === node.id;

  const settings = node.element.settings;
  const designStyles = generateHeadingDesignStyles();

  const headingRef = useRef<HTMLParagraphElement>(null);

  function dispatchText(prevText: string, nextText: string) {
    const prevElementSettings: TUpdatedElementSettings = {
      type: "heading",
      settings: {
        ...cloneDeep(settings),
        text: prevText,
      },
    };

    const nextElementSettings: TUpdatedElementSettings = {
      type: "heading",
      settings: {
        ...cloneDeep(settings),
        text: nextText,
      },
    };

    dispatch(
      websiteBuilderUpdateElementSettings({
        id: node.id,
        prevElementSettings,
        nextElementSettings,
      }),
    );
  }

  const { cursor, contentEditable, handleOnPaste } = useElementViewTextEditor({
    id: node.id,
    text: settings.text,
    level: settings.level,
    editingText,
    dispatchText,
    ref: headingRef,
  });

  return React.createElement(`h${settings.level}`, {
    ref: headingRef,
    className: classNames(designStyles.className, "element-content", {
      "element-content-selected": headingSelected,
    }),
    style: {
      ...designStyles.style,
      cursor,
    },
    contentEditable,
    onPaste: handleOnPaste,
  });
}
